import Reveal from "@/components/feature/Reveal";
import { BUSINESS, LINKS } from "@/constants/site";

export default function LocationSection() {
  return (
    <section id="ubicacion" className="w-full bg-ink py-14 md:py-24">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-6">
        <Reveal className="text-center">
          <h2 className="font-serif text-4xl text-peach md:text-6xl">Cómo llegar</h2>
          <p className="mt-4 text-base text-cream md:text-lg">
            Te esperamos en Armenia, Quindío.
          </p>
        </Reveal>

        <Reveal className="mt-10">
          <div className="h-[300px] w-full overflow-hidden rounded-xl2 border border-malva/40 md:h-[420px]">
            <iframe
              title="Mapa de ubicación de CLEM by Cerón en Armenia, Quindío"
              src={LINKS.mapsEmbed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="h-full w-full border-0"
            />
          </div>
        </Reveal>

        <Reveal className="mt-8">
          <div className="rounded-xl2 border border-malva/40 bg-card p-5 md:p-7">
            <ul className="flex flex-col gap-5">
              <li className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-peach/15 text-peach">
                  <i className="ri-map-pin-2-line text-xl" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.16em] text-sand">
                    Dirección
                  </p>
                  <p className="mt-1 text-base text-cream">{BUSINESS.address}</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-peach/15 text-peach">
                  <i className="ri-time-line text-xl" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.16em] text-sand">
                    Horario
                  </p>
                  <p className="mt-1 text-base leading-relaxed text-cream">{BUSINESS.hours}</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-peach/15 text-peach">
                  <i className="ri-building-line text-xl" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.16em] text-sand">
                    Ciudad
                  </p>
                  <p className="mt-1 text-base text-cream">Armenia, Quindío</p>
                </div>
              </li>
            </ul>
          </div>
        </Reveal>

        <Reveal className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href={LINKS.maps}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-peach px-7 text-base font-semibold text-ink transition-colors hover:bg-[#eeb987] sm:w-auto"
          >
            <i className="ri-navigation-line text-lg" aria-hidden="true" />
            Cómo llegar en Google Maps
          </a>
          <a
            href={LINKS.maps}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-peach px-7 text-base font-medium text-peach transition-colors hover:bg-peach hover:text-ink sm:w-auto"
          >
            <i className="ri-star-line text-lg" aria-hidden="true" />
            Ver reseñas en Google
          </a>
        </Reveal>
      </div>
    </section>
  );
}